/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InboundDocumentWorkStatus = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
} as const;
export type InboundDocumentWorkStatus = typeof InboundDocumentWorkStatus[keyof typeof InboundDocumentWorkStatus];


export function instanceOfInboundDocumentWorkStatus(value: any): boolean {
    for (const key in InboundDocumentWorkStatus) {
        if (Object.prototype.hasOwnProperty.call(InboundDocumentWorkStatus, key)) {
            if (InboundDocumentWorkStatus[key as keyof typeof InboundDocumentWorkStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InboundDocumentWorkStatusFromJSON(json: any): InboundDocumentWorkStatus {
    return InboundDocumentWorkStatusFromJSONTyped(json, false);
}

export function InboundDocumentWorkStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentWorkStatus {
    return json as InboundDocumentWorkStatus;
}

export function InboundDocumentWorkStatusToJSON(value?: InboundDocumentWorkStatus | null): any {
    return value as any;
}

export function InboundDocumentWorkStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InboundDocumentWorkStatus {
    return value as InboundDocumentWorkStatus;
}

